import { AnalyticsEventActions, AnalyticsEventFeatures } from '../typings/analytics';
export const getReviewEventCreator = (baseEvent, paymentFormValues, paymentOptionObj) => {
    if (baseEvent.feature === AnalyticsEventFeatures.MAKE_A_PAYMENT) {
        return () => ({
            event: Object.assign(Object.assign(Object.assign({}, baseEvent), paymentOptionObj), { action: AnalyticsEventActions.REVIEW, payment_type: paymentFormValues.paymentType, payment_amount: paymentFormValues.paymentAmount, payment_submit_date: paymentFormValues.paymentSubmitDate, payment_scheduled_date: paymentFormValues.paymentScheduledDate, payment_method_type: paymentFormValues.paymentMethodType, payment_from: paymentFormValues.paymentFrom, one_click_autopay: paymentFormValues.oneClickAutopay })
        });
    }
    return () => {
        throw new Error(`No review event object implemented for ${baseEvent.feature}`);
    };
};
